import deleteEmptyElementsInObjectRecursive from "../../functions/deleteEmptyJsonElements";
import updateFhirJson from "../../functions/updateFhirJsonAPI";
import { editModeOff } from "../../slices/editMode/editModeSlice";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { triggerRefreshOn } from "../../slices/triggerRefresh/triggerRefreshSlice";
import getDisplayTitle from "./getDisplayTitle";
import saveAllChanges from "./saveAllChanges";

const submitUpdatedResource = async (foi, parentResourceDetail, apiToken, connectionId, dispatch, resourceCollection,
    changedResourcesList, tabFocus, jsonViewEditingState, setJsonViewEditingState, setParentResourceAlertModalState = undefined, addToast = null) => {
    dispatch(globalLoadingOn());
    if (tabFocus === "Text View") {
        let successfulChange = await saveAllChanges(foi, apiToken, connectionId, parentResourceDetail, resourceCollection,
            changedResourcesList, dispatch, setParentResourceAlertModalState);
        if (successfulChange === "successful") {
            dispatch(triggerRefreshOn());
            console.log("triggered refresh here");
            dispatch(editModeOff());
        }
    } else if (tabFocus === "JSON View") {
        let fhirJson;
        try {
            fhirJson = jsonViewEditingState.fhirEntryStringRevised ? JSON.parse(jsonViewEditingState.fhirEntryStringRevised) : JSON.parse(jsonViewEditingState.fhirEntryString);
        } catch {
            alert("Invalid JSON");
        }
        if (fhirJson) {
            deleteEmptyElementsInObjectRecursive(fhirJson);
            setJsonViewEditingState(prevState => {
                return {
                    ...prevState,
                    "fhirEntryStringRevised": JSON.stringify(fhirJson, null, 2)
                }
            });
            let response = await updateFhirJson(foi, fhirJson, getDisplayTitle(fhirJson, parentResourceDetail), apiToken, connectionId, jsonViewEditingState.status, null, null, setParentResourceAlertModalState !== undefined);
            if (response?.success) {
                if (addToast) {
                    addToast('The resource has been updated.', { appearance: 'success' });
                }
                if (response.parentResourcesToBeAlertedTo?.length && setParentResourceAlertModalState) {
                    setParentResourceAlertModalState(prevState => {
                        return {
                            ...prevState,
                            modalOpen: true,
                            parentResourcesToBeAlertedTo: response.parentResourcesToBeAlertedTo
                        };
                    });
                } else {
                    //reloadCurrentResource(resourceType, resourceId, removeHash, fhirEntryState, changeFormState, history);
                }
                dispatch(triggerRefreshOn());
                console.log("triggered refresh here");
                dispatch(editModeOff());
            }
        }
    } else if (tabFocus === "Term Detail") {
        let successfulChange = await saveAllChanges(foi, apiToken, connectionId, parentResourceDetail, resourceCollection,
            changedResourcesList, dispatch);
        if (successfulChange === "successful") {
            dispatch(triggerRefreshOn());
            console.log("triggered refresh here");
            dispatch(editModeOff());
        }
    }
    dispatch(globalLoadingOff());
};

export default submitUpdatedResource;